import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | NRI Property Services" description="The page you're looking for doesn't exist." path="/404" />
      <section className="flex min-h-[80vh] items-center bg-navy-900 pt-24" data-testid="not-found-page">
        <div className="container-site py-20 text-center">
          <p className="font-display text-7xl font-extrabold tracking-tight text-gold-500 sm:text-8xl">404</p>
          <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            This page has moved out.
          </h1>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/60 sm:text-base">
            The page you&rsquo;re looking for doesn&rsquo;t exist — but your property management is still one click away.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/" className="btn-gold" data-testid="not-found-home">
              Back to Home <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/contact" className="btn-ghost-light" data-testid="not-found-contact">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
